import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowLeftFromBracketSharp = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.334 18h4.667V6h-4.667V4h6.667v16h-6.667v-2ZM11.081 7.332l-.707.708L7.418 11h8.693v2h-8.7l2.963 2.959.707.706-1.413 1.415-.708-.706-4.666-4.662-.708-.707.707-.707 4.666-4.672.707-.707 1.415 1.413Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowLeftFromBracketSharp);
export default Memo;
